import { render, staticRenderFns } from "./__index_batch_update_tag.vue?vue&type=template&id=4747fdda&"
import script from "./__index_batch_update_tag.vue?vue&type=script&lang=js&"
export * from "./__index_batch_update_tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports